/* eslint-disable max-len */
import React from 'react';

const Increase = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.33058 4.33058C2.5 6.16117 2.5 9.10744 2.5 15C2.5 20.8926 2.5 23.8388 4.33058 25.6694C6.16117 27.5 9.10744 27.5 15 27.5C20.8926 27.5 23.8388 27.5 25.6694 25.6694C27.5 23.8388 27.5 20.8926 27.5 15C27.5 9.10744 27.5 6.16117 25.6694 4.33058C23.8388 2.5 20.8926 2.5 15 2.5C9.10744 2.5 6.16117 2.5 4.33058 4.33058Z"
      fill="#E85D04"
    />
    <path
      d="M17.797 11.8035C17.797 12.4655 18.3336 13.0022 18.9957 13.0022H20.0974L16.8808 16.2188C16.7248 16.3748 16.4718 16.3748 16.3157 16.2188L13.7812 13.6843C12.6889 12.592 10.918 12.592 9.82573 13.6843L6.16109 17.3489C5.69297 17.817 5.69297 18.576 6.16109 19.0441C6.62921 19.5122 7.38818 19.5122 7.8563 19.0441L11.5209 15.3795C11.677 15.2234 11.93 15.2234 12.086 15.3795L14.6205 17.914C15.7128 19.0063 17.4837 19.0063 18.576 17.914L21.7926 14.6974V15.7991C21.7926 16.4612 22.3293 16.9978 22.9913 16.9978C23.6533 16.9978 24.19 16.4612 24.19 15.7991V11.8035C24.19 11.1415 23.6533 10.6048 22.9913 10.6048H18.9957C18.3336 10.6048 17.797 11.1415 17.797 11.8035Z"
      fill="white"
    />
  </svg>
);

export default Increase;
